// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Update, Delete.
// MODIFIED DATE : 14-08-2025

import { docodeHexResponse } from '../../../_common/common.utils';
import GroupAccountActionTypes from './groupAccount.types';

const INITIAL_STATE = {
	// Add Group Account Details Response
	addGroupAccountDetailsResponse: null,

	// Update Group Account Details Response
	updateGroupAccountDetailsResponse: null,

	// Get Group Account List Response
	getGroupAccountListResponse: null,

	// Get Group Account List Array
	getGroupAccountListArr: [],

	// Get Primary Account List Resposne
	getPrimaryAccountListResponse: null,

	// Get Primary Account List Array
	getPrimaryAccountListArr: [],

	// Fetch Group Account Details Resposne
	fetchGroupAccountDetailsResponse: null,

	// Fetch Group Account Details Array
	fetchGroupAccountDetailsArr: [],

	// Delete Group Account Details Resposne
	deleteGroupAccountDetailsResponse: null,

	// All Group Account Export Response
	allGroupAccountExportResponse: null,

	// All Group Account Export Data Array (if applicable)
	allGroupAccountExportArr: [],
};

const groupAccountReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD GROUP ACCOUNT DETAILS START *********************** */
		case GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, addGroupAccountDetailsResponse: action.payload };

		case GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, addGroupAccountDetailsResponse: action.payload };

		case GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, addGroupAccountDetailsResponse: null };
		/** ***************** ADD GROUP ACCOUNT DETAILS END *********************** */

		/** ***************** UPDATE GROUP ACCOUNT DETAILS START *********************** */
		case GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, updateGroupAccountDetailsResponse: action.payload };

		case GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, updateGroupAccountDetailsResponse: action.payload };

		case GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateGroupAccountDetailsResponse: null };
		/** ***************** UPDATE GROUP ACCOUNT DETAILS END *********************** */

		/** ***************** GET GROUP ACCOUNT LIST START *********************** */
		case GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_SUCCESS:
			return {
				...state,
				getGroupAccountListResponse: action.payload,
				getGroupAccountListArr: docodeHexResponse(action.payload, 'GetGroupAccountListKey'),
			};

		case GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_FAILURE:
			return { ...state, getGroupAccountListResponse: action.payload };

		case GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_RESPONSE_CHANGED:
			return { ...state, getGroupAccountListResponse: null };
		/** ***************** GET GROUP ACCOUNT LIST END *********************** */

		/** ***************** GET PRIMARY ACCOUNT LIST START *********************** */
		case GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_SUCCESS:
			return {
				...state,
				getPrimaryAccountListResponse: action.payload,
				getPrimaryAccountListArr: docodeHexResponse(
					action.payload,
					'GetPrimaryAccountListKey',
				),
			};

		case GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_FAILURE:
			return { ...state, getPrimaryAccountListResponse: action.payload };

		case GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_RESPONSE_CHANGED:
			return { ...state, getPrimaryAccountListResponse: null };
		/** ***************** GET PRIMARY ACCOUNT LIST END *********************** */

		/** ***************** FETCH GROUP ACCOUNT DETAILS START *********************** */
		case GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return {
				...state,
				fetchGroupAccountDetailsResponse: action.payload,
				fetchGroupAccountDetailsArr: docodeHexResponse(
					action.payload,
					'GetParticularAccountListKey',
				),
			};

		case GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, fetchGroupAccountDetailsResponse: action.payload };

		case GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchGroupAccountDetailsResponse: null };
		/** ***************** FETCH GROUP ACCOUNT DETAILS END *********************** */

		/** ***************** DELETE GROUP ACCOUNT DETAILS START *********************** */
		case GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, deleteGroupAccountDetailsResponse: action.payload };

		case GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, deleteGroupAccountDetailsResponse: action.payload };

		case GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteGroupAccountDetailsResponse: null };
		/** ***************** DELETE GROUP ACCOUNT DETAILS END *********************** */

		/************** GROUP ACCOUNT EXPORTS START ************** */
		case GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_SUCCESS:
			return {
				...state,
				allGroupAccountExportResponse: action.payload,
				allGroupAccountExportArr: docodeHexResponse(
					action.payload,
					'AllGroupAccountExportKey',
				),
			};

		case GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_FAILURE:
			return { ...state, allGroupAccountExportResponse: action.payload };

		case GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_RESPONSE_CHANGED:
			return { ...state, allGroupAccountExportResponse: null };
		/************** GROUP ACCOUNT EXPORTS END ************** */

		default:
			return state;
	}
};
export default groupAccountReducer;
